import { render } from "./Sidenav.vue?vue&type=template&id=570f17f3&scoped=true"
import script from "./Sidenav.vue?vue&type=script&lang=js"
export * from "./Sidenav.vue?vue&type=script&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=570f17f3&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570f17f3"]])

export default __exports__